// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1BOiT","infoBtn":"quickbooks_infoBtn__1AB8H","formBox":"quickbooks_formBox__RRzZF","formFooter":"quickbooks_formFooter__1Ib16"};